import React from 'react';
import {
    Datagrid,
    List,
    TextField,
    EditButton,
    DeleteButton,
    ShowButton,
    ReferenceField,
} from 'react-admin';

const TemplateVariant = (props: any) => {
    return (
        <List {...props}>
            <Datagrid>
                <TextField source='id' />
                <TextField source='language' />
                <TextField source='flowId' />
                <ReferenceField label="template" source="template" reference="Template" link="show">
                    <TextField source="name" />
                </ReferenceField>
                <TextField source='content'/>
                <DeleteButton/>
                <EditButton/>
                <ShowButton/>
            </Datagrid>
        </List>
    );
};

export default TemplateVariant;